import { OwaDate, differenceInMinutes } from 'owa-datetime';

const DEFAULT_DURATION = 30;
export function getValidDuration(eventStart: OwaDate, eventEnd: OwaDate): number {
    const eventDuration = differenceInMinutes(eventEnd, eventStart);
    return eventDuration > 0 ? eventDuration : DEFAULT_DURATION;
}
